import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectOptions } from './select.types';

@Component({
  selector: 'cohrex-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectComponent {
  private _controlName?: string = '';
  @Input()
  set controlName(value: string | undefined) {
    this._controlName = value;
  }
  get controlName(): string | undefined {
    return this._controlName;
  }

  private _options?: SelectOptions[];
  @Input()
  set options(value: SelectOptions[] | undefined) {
    this._options = value;
  }
  get options(): SelectOptions[] | undefined {
    return this._options;
  }

  private _form?: FormGroup;
  @Input()
  set form(value: FormGroup | undefined) {
    this._form = value;
  }
  get form(): FormGroup | undefined {
    return this._form;
  }

  private _helperText?: string = '';
  @Input()
  set helperText(value: string | undefined) {
    this._helperText = value;
  }
  get helperText(): string | undefined {
    return this._helperText;
  }

  private _groupName?: string = '';
  @Input()
  set groupName(value: string | undefined) {
    this._groupName = value;
  }
  get formGroupName(): string | undefined {
    return this._groupName;
  }

  private _isError?: boolean = false;
  @Input()
  set isError(value: boolean | undefined) {
    this._isError = value;
  }
  get isError(): boolean | undefined {
    return this._isError;
  }

  private _disabled?: boolean = false;
  @Input()
  set disabled(value: boolean | undefined) {
    this._disabled = value;
  }
  get disabled(): boolean | undefined {
    return this._disabled;
  }

  private _loading?: boolean = false;
  @Input()
  set loading(value: boolean | undefined) {
    this._loading = value;
  }
  get loading(): boolean | undefined {
    return this._loading;
  }

  @Input() placeholder: string = '';
  @Input() className: string = '';
  @Input() label: string = '';
  @Input() multiple: boolean = false;
  @Input() searchable: boolean = true;
  @Output() changed: EventEmitter<SelectOptions> = new EventEmitter();

  handleChange(event: number): void {
    this.changed.emit(this.options?.[event - 1]);
  }
}
